import React from "react";

type PropsType = {
  className?: string;
  size?: number;
};

const Campaigns: React.FC<PropsType> = ({ size = 50, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
    >
      <g clip-path="url(#clip0_272_13141)">
        <rect
          x="14.2393"
          y="36.6497"
          width="11.3565"
          height="5"
          rx="2.5"
          transform="rotate(45 14.2393 36.6497)"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linecap="round"
        />
        <circle
          cx="28.9697"
          cy="16.6151"
          r="4.58333"
          transform="rotate(45 28.9697 16.6151)"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linecap="round"
        />
        <path
          d="M15.5064 5.47413C15.7235 4.91213 16.4469 4.7592 16.873 5.18522L40.4006 28.7128C40.8266 29.1389 40.6737 29.8623 40.1117 30.0794L12.1532 40.8822C10.0267 41.7039 7.61566 41.1942 6.00363 39.5822C4.3916 37.9701 3.88188 35.5591 4.70355 33.4326L15.5064 5.47413Z"
          fill="white"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linecap="round"
        />
        <path
          d="M33.0962 31.9357L13.6508 12.4902L16.6689 5L40.8356 29.1667L33.0962 31.9357Z"
          fill="#FF878F"
        />
        <path
          d="M13.6504 12.4905L33.0958 31.9359"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linecap="round"
        />
        <path
          d="M32.5047 8.36566L34.2725 3.65161"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linecap="round"
        />
        <path
          d="M37.5145 13.3745L42.2285 11.6067"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linecap="round"
        />
        <path
          d="M26.6137 7.7762L26.0244 2.4729"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linecap="round"
        />
        <path
          d="M38.1039 19.2667L43.4072 19.856"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linecap="round"
        />
        <path
          d="M15.5064 5.47413C15.7235 4.91213 16.4469 4.7592 16.873 5.18522L40.4006 28.7128C40.8266 29.1389 40.6737 29.8623 40.1117 30.0794L12.1532 40.8822C10.0267 41.7039 7.61566 41.1942 6.00363 39.5822V39.5822C4.3916 37.9701 3.88188 35.5591 4.70355 33.4326L15.5064 5.47413Z"
          stroke="#003125"
          stroke-width="3.33333"
          stroke-linecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_272_13141">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Campaigns;
